export const adjective = {
	singular: "parent",
	plural: "parents",
};
